import * as React from "react";
import Button from "@material-ui/core/Button";
import {Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import UseHubHeader from "./hooks/UseHubHeader";
import BuildInitializer from "./BuildInitializer";

export default function HubHeader({hubId, build, children, onLaunch, onStop}) {
    const launched = build && (build.status === "PENDING" || build.status === "RUNNING");

    const {opened, elapsedTime, handleOpen, handleClose} = UseHubHeader({
        buildId: build && build.id,
        buildCreateAt: build && build["created_at"],
        buildLaunched: launched
    });

    if (launched) {
        return (
            <Grid container spacing={1} justify={"space-between"} alignItems={"center"}>
                <Grid item>
                    <Button size="small"
                            variant="contained"
                            color="secondary"
                            onClick={() => onStop()}
                    >Stop</Button>
                </Grid>
                <Grid item>
                    <Tooltip title={`Last run: ${build["created_at"]}`}>
                        <Typography>Elapsed time: {elapsedTime || "00:00:00"}</Typography>
                    </Tooltip>
                </Grid>
                <Grid item>
                    {children}
                </Grid>
            </Grid>
        );
    } else {
        return (
            <Grid container spacing={1} justify={"space-between"} alignItems={"center"}>
                <Grid item>
                    <Button size="small"
                            variant="contained"
                            color="primary"
                            onClick={handleOpen}
                    >
                        Create Build
                    </Button>
                    <BuildInitializer hubId={hubId}
                                      opened={opened}
                                      handleLaunch={onLaunch}
                                      handleCancel={handleClose}
                    />
                </Grid>
                <Grid item>
                    {children}
                </Grid>
            </Grid>
        );
    }
}